import { render } from "./App.vue?vue&type=template&id=f1f44a2a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f1f44a2a&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__